import { useContext } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api, type ShiftTask, type IUpdateTask } from "@/logic/api";
import { SessionContext } from "@/utility/useSession";
import { useApiWithReject } from "@/utility/utils";

export const useUpdateShiftTask = () => {
    const { current: session } = useContext(SessionContext);
    const queryClient = useQueryClient();
    const updateTaskApi = useApiWithReject(api.hooks.shift.updateTask());

    const userUuid = session?.site?.user?.uuid;
    const tenantId = session?.site?.tenant?.id;

    return useMutation<ShiftTask, Error, IUpdateTask>({
        mutationFn: async (payload) => {
            if (!session?.context) {
                throw new Error("Session context not available");
            }
            return updateTaskApi.send(session.context, payload);
        },
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: ["shiftTasks", userUuid, tenantId] });
        },
    });
};
